import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';

const SEARCH_DEBOUNCE_MS = 400;

export const useUrlSearch = (paramName = 'q') => {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get(paramName) ?? '';
  const page = Math.max(0, Number(searchParams.get('page')) || 0);

  const [search, setSearch] = useState(query);

  useEffect(() => {
    if (search === query) return;
    const timer = setTimeout(() => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (search) next.set(paramName, search);
          else next.delete(paramName);
          next.delete('page');
          return next;
        },
        { replace: true },
      );
    }, SEARCH_DEBOUNCE_MS);
    return () => { clearTimeout(timer); };
  }, [search, query, paramName, setSearchParams]);

  const goToPage = (next: number) =>
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set('page', String(next));
      return params;
    });

  return { query, page, search, setSearch, goToPage };
};
